import React from "react";
import './App.css';
import { useNavigate } from 'react-router';

import { useForm } from "react-hook-form";



export function Login() {

    const navigate = useNavigate();
    const {register, handleSubmit} = useForm();
    const handleRegistration = async (data) => {
        //console.log(data);

        await fetch('/login', {
            method: 'POST',
            headers: {
                Accept: 'application/form-data',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });
        navigate("/");
    }




    return (
        <div className="login">
            <form action="/login" method="post" onSubmit={handleSubmit(handleRegistration)}>

                <input {...register("userName")} placeholder="User" type="text"/>
                <input {...register("userPass")} placeholder="Password" type="password"/>

                <input type="submit" />

            </form>
        </div>
    );
}

export default Login;
